import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { StateStorageService } from './state-storage.service';
import { map } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import { SessionStorageService } from 'ngx-webstorage';
import { LoginService } from '../login/login.service';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService {
  constructor(
    private userService: UserService,
    private sessionStorageService: SessionStorageService,
    private stateStorageService: StateStorageService,
    private loginService: LoginService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): Observable<boolean> {
    return this.userService.identity().pipe(
      map(account => {
        if (
          this.sessionStorageService.retrieve('wsb-routing-allowed') === true ||
          this.sessionStorageService.retrieve('wsb-routing-allowed') === null ||
          url === '/dashboard'
        ) {
          if (account) {
            return this.userService.isAuthenticated();
          }
          this.stateStorageService.storeUrl(url);
          this.loginService.redirectToLogin();
          return false;
        } else {
          return false;
        }
      })
    );
  }
}
